// Angular
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { RouterModule } from '@angular/router';
// Bootstrap
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
// Translate
import { TranslateModule } from '@ngx-translate/core';
// Prime Ng
import { InplaceModule } from 'primeng/inplace';
import { InputTextModule } from 'primeng/inputtext';
import { RippleModule } from 'primeng/ripple';
import { SkeletonModule } from 'primeng/skeleton';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { DropdownModule } from "primeng/dropdown";
// Medsurf Lib
import { FlatDesignModule } from '@medsurf/flat-designs';
// Modules
import 'tinymce';
import { EditorModule } from '@tinymce/tinymce-angular';
// Components
// -- Custom Enumeration
import { CustomEnumerationComponent } from './custom-enumeration/custom-enumeration.component';
// -- Editor
import { EditorComponent } from './editor/editor.component';
import { AnnotationEditorDialogComponent } from './editor/dialog/annotation-editor-dialog/annotation-editor-dialog.component';
import { LinkEditorDialogComponent } from './editor/dialog/link-editor-dialog/link-editor-dialog.component';
// -- Media Library
import { MediaLibraryComponent } from './media-library/media-library.component';
import { MediaSidebarComponent } from './media-library/media-sidebar/media-sidebar.component';
import { CopyrightComponent } from './media-library/media-sidebar/copyright/copyright.component';
import { MediaLibraryModalComponent } from './media-library/media-library-modal/media-library-modal.component';
// -- Navbar
import { NavbarComponent } from './navbar/navbar.component';
// -- Node Tree
import { NodeTreeComponent } from './node-tree/node-tree.component';
// -- Node Tree Modal
import { NodeTreeModalComponent } from './node-tree-modal/node-tree-modal.component';
// -- Page Title Dialog
import { PageTitleDialogComponent } from "./page-title-dialog/page-title-dialog.component";
// -- Page Link Dialog
import { PageLinkDialogComponent } from './page-link-dialog/page-link-dialog.component';
// -- Permission Dialog
import { PermissionDialogComponent } from './permission-dialog/permission-dialog.component';
// -- Route
import { RouteComponent } from './route/route.component';
// -- Slide Tree
import { SlideTreeComponent } from "./slide-tree/slide-tree.component";
// -- Toolbar
import { ToolbarComponent } from "./toolbar/toolbar.component";
import { SessionRefreshDialogComponent } from './session-refresh-dialog/session-refresh-dialog.component';
import { ProgressSpinnerModule } from 'primeng/progressspinner';

@NgModule({
	imports: [
    // Angular
    CommonModule,
    DragDropModule,
    RouterModule,
    // Bootstrap
    NgbModule,
    // Translate
    TranslateModule.forChild(),
    // Medsurf Lib
    FlatDesignModule,
    // Modules
    EditorModule,
    InplaceModule,
    InputTextModule,
    RippleModule,
    SkeletonModule,
    OverlayPanelModule,
    DropdownModule,
    ProgressSpinnerModule
],
  declarations: [
    // Components
    // -- Custom Enumeration
    CustomEnumerationComponent,
    // -- Editor
    EditorComponent,
    AnnotationEditorDialogComponent,
    LinkEditorDialogComponent,
    // -- Media Library
    MediaLibraryComponent,
    MediaSidebarComponent,
    CopyrightComponent,
    MediaLibraryModalComponent,
    // -- Navbar
    NavbarComponent,
    // -- Node Tree
    NodeTreeComponent,
    // -- Node Tree Modal
    NodeTreeModalComponent,
    // -- Page Title Dialog
	  PageTitleDialogComponent,
    // -- Page Link Dialog
    PageLinkDialogComponent,
    // -- Permission Dialog
    PermissionDialogComponent,
    // -- Session Refresh Dialog
    SessionRefreshDialogComponent,
    // -- Route
    RouteComponent,
    // -- Slide Tree
    SlideTreeComponent,
    // -- Toolbar
    ToolbarComponent,
  ],
  exports: [
    // Components
    // -- Custom Enumeration
    CustomEnumerationComponent,
    // -- Editor
    EditorComponent,
    AnnotationEditorDialogComponent,
    LinkEditorDialogComponent,
    // -- Media Library
    MediaLibraryComponent,
    MediaLibraryModalComponent,
    // -- Navbar
    NavbarComponent,
    // -- Node Tree
    NodeTreeComponent,
    // -- Node Tree Modal
    NodeTreeModalComponent,
    // -- Page Title Dialog
	  PageTitleDialogComponent,
    // -- Page Link Dialog
    PageLinkDialogComponent,
    // -- Permission Dialog
    PermissionDialogComponent,
    // -- Session Refresh Dialog
    SessionRefreshDialogComponent,
    // -- Route
    RouteComponent,
    // -- Slide Tree
    SlideTreeComponent,
    // -- Toolbar
    ToolbarComponent,
  ],
})
export class MedsurfCommonModule {
}
